import React from 'react';
import P3Configuration from 'models/P3Configuration';
import { P3Configuration as IP3Configuration } from 'models/interfaces/P3Configurations';
import { PureQueryOptions, ApolloClient } from 'apollo-client';
import P3TemplateList from './P3TemplateList';
import P3TemplateEdit from './P3TemplateEdit';
import P3TemplateAssign from 'views/components/Modal/P3TemplateAssign';
import { GET_ADVERTISER_DATA_QUERY } from 'containers/ThomasAdvertiserCampaignsContainer';
import {
  getAdvertisers,
  buildAdvertisersOptions
} from 'views/components/ThomasAdvertisers/ThomasAdvertiserOptions';

import {
  saveP3Configurations,
  duplicateP3Configuration,
  deleteP3Configuration,
  asssignP3Configuration
} from './P3TemplateEditConfiguration';
import { toast } from 'react-toastify';
import { TABS_CONFIGURATIONS } from 'models/constants';
import { CONSTANTS } from '@tpco/tpco-saturn-types';
import uuid from 'uuid/v4';
import { ConfigurationsPageCache } from 'models/interfaces/PageCache';
import Tab from '../Tab/Tab';
import P3AssignedTemplateList from './P3AssignedTemplateList';

interface P3TemplatesViewProps {
  client: ApolloClient<any>;
  configurationsPageCache: ConfigurationsPageCache;
  updateCache: any;
}

interface P3TemplatesViewState {
  isModalOpen: boolean;
  isEditAssign: boolean;
  currentTemplate: IP3Configuration;
  formTitle: string;
  advertiserList: any;
  activeTab: string;
}
export function refetchQueries(tgrams_id: string) {
  const refetchThomasCampaign = {
    query: GET_ADVERTISER_DATA_QUERY,
    variables: { tgrams_id }
  } as PureQueryOptions;

  return [refetchThomasCampaign];
}

class P3TemplatesView extends React.Component<P3TemplatesViewProps, P3TemplatesViewState> {
  constructor(props: P3TemplatesViewProps) {
    super(props);

    this.state = {
      isEditAssign: false,
      isModalOpen: false,
      currentTemplate: P3Configuration.newUserTemplate(),
      formTitle: 'Edit Configuration',
      advertiserList: buildAdvertisersOptions(this.getAdvertisersList()),
      activeTab: props.configurationsPageCache.activeTab
    };
  }

  toggleTemplateModal = (template?: IP3Configuration) => {
    const { isModalOpen } = this.state;

    if (template) {
      // template selected from list
      this.setState({
        isModalOpen: !isModalOpen,
        currentTemplate: template,
        formTitle: 'Edit Configuration'
      });
    } else {
      // create template selected, need to create new template
      const newTemplate = P3Configuration.newUserTemplate();
      this.setState({
        isModalOpen: !isModalOpen,
        currentTemplate: newTemplate,
        formTitle: 'Create Configuration'
      });
    }
  };

  onClose = () => this.setState({ isModalOpen: false, isEditAssign: false });

  duplicateTemplate = (templateId: string) => {
    const { client } = this.props;

    const newConfigId = uuid();
    const postMutateFunc = () => toast.success('Template successfully duplicated.');

    duplicateP3Configuration(
      client,
      templateId,
      newConfigId,
      undefined,
      undefined,
      undefined,
      postMutateFunc
    );
  };

  deleteTemplate = (templateId: string) => {
    const { client } = this.props;

    const postMutateFunc = () => toast.success('Template successfully deleted.');

    deleteP3Configuration(client, templateId, undefined, postMutateFunc);
  };

  assignTemplate = (template: IP3Configuration) => {
    const { isModalOpen } = this.state;
    // const { client } = this.props;
    // const postMutateFunc = () => toast.info('You can see the template on the Company Page...', {
    //   autoClose: 2000
    // });
    // deleteP3Configuration(client, templateId, undefined, postMutateFunc);
    if (template) {
      template.description = template.description ? template.description : '';
    }

    this.setState({
      isModalOpen: !isModalOpen,
      currentTemplate: template,
      isEditAssign: true
    });
  };

  saveTemplate = async (template: IP3Configuration) => {
    const { client } = this.props;

    console.log('Saving template...');
    console.log('template: ', template);
    const {
      data: { saveP3Configuration }
    } = await saveP3Configurations(client, template);

    console.log('saveP3Configuration: ', saveP3Configuration);

    this.setState(
      {
        currentTemplate: saveP3Configuration
      },
      () => {
        toast.info('Redirecting to Positioning Module to complete configuration...', {
          autoClose: 2000
        });
        setTimeout(() => {
          this.navigateToPositioningModule();
        }, 2000);
      }
    );
  };

  getAdvertisersList = async () => {
    const { client } = this.props;
    let list = await getAdvertisers(client);
    // console.log(`adv`, list);
    return list;
  };

  saveAssignmentTemplate = async (values: any) => {
    console.log(`save Assign Template Values`, values);
    const { client } = this.props;

    const postMutateFunc = () => toast.success('Configuration successfully assigned.');

    asssignP3Configuration(
      client,
      values.p3_configuration_id,
      values.tgrams_id,
      values.name,
      refetchQueries(values.tgrams_id),
      postMutateFunc
    );
    this.onClose();
  };

  navigateToPositioningModule = () => {
    const { currentTemplate } = this.state;

    if (!currentTemplate) {
      console.log('CurrentTemplate is missing.');
      toast.error('Something went wrong navigating to configuration.');
      return;
    }
    let path = `${CONSTANTS.RANKALYZER_BASE_PATH}?config_id=${currentTemplate.p3_configuration_id}`;
    window.location.href = path;
  };

  onClickTabItem = tab => {
    console.log('tab selected', tab);
    this.setState({ activeTab: tab });
  };

  render() {
    const {
      configurationsPageCache: { tabOptions, Assigned, Unassigned }
    } = this.props;

    const {
      isModalOpen,
      currentTemplate,
      formTitle,
      isEditAssign,
      advertiserList,
      activeTab
    } = this.state;
    return (
      <section>
        <div className="flex-row flex-wrap">
          <h1 className="page-title">Configurations</h1>
          {isModalOpen && !isEditAssign ? (
            <P3TemplateEdit
              isModalOpen={isModalOpen}
              companyName=""
              formTitle={formTitle}
              template={currentTemplate}
              onClose={this.onClose}
              onSaveConfig={this.saveTemplate}
            />
          ) : null}
          {isModalOpen && isEditAssign ? (
            <P3TemplateAssign
              isModalOpen={isModalOpen}
              template={currentTemplate}
              onClose={this.onClose}
              advertisers={advertiserList}
              onSaveAssign={this.saveAssignmentTemplate}
            />
          ) : null}
          <a className="header-title-btn">
            <button
              onClick={() => this.toggleTemplateModal()}
              className="btn btn-primary"
              style={{ float: 'right' }}
            >
              Create Configuration
            </button>
          </a>
        </div>

        <div className="card">
          <ul className="page-tabs page-tabs--card">
            {tabOptions.map((tab, i) => {
              return (
                <Tab
                  key={`${tab} - ${i}`}
                  activeTab={activeTab}
                  label={tab}
                  onClick={this.onClickTabItem}
                />
              );
            })}
          </ul>
          <div className="content-card content-card--pattern mb-4">
            {activeTab === TABS_CONFIGURATIONS.ASSIGNED ? (
              <P3AssignedTemplateList
                templates={Assigned}
                showAssignTemplate={true}
                editTemplate={this.toggleTemplateModal}
                duplicateTemplate={this.duplicateTemplate}
                deleteTemplate={this.deleteTemplate}
                assignTemplate={this.assignTemplate}
              />
            ) : (
              <P3TemplateList
                templates={Unassigned}
                showAssignTemplate={true}
                editTemplate={this.toggleTemplateModal}
                duplicateTemplate={this.duplicateTemplate}
                deleteTemplate={this.deleteTemplate}
                assignTemplate={this.assignTemplate}
              />
            )}
          </div>
        </div>
      </section>
    );
  }
}

export default P3TemplatesView;
